import ProductPricingIcon from '@mui/icons-material/MonetizationOn';

import  ProductPricingList  from './ProductPricingList';
import { ProductPricingEdit } from './ProductPricingEdit';

export default {
    list: ProductPricingList,
    edit: ProductPricingEdit,
    icon: ProductPricingIcon,
};